import React, { useState } from "react";
import Modal from "../../../../components/ui/Modal";
import Button from "../../../../components/ui/Button";
import ImageUpload from "../../../../components/ui/ImageUpload";
import { UploadCloud } from "lucide-react";

const UploadMediaModal = ({ isOpen, onClose, onUpload }) => {
  // In a real app, this would handle file objects. For the prototype, we'll just simulate the flow.
  const [fileSelected, setFileSelected] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleSaveClick = () => {
    // Create a mock new media item
    const newItem = {
      id: `M-${Math.floor(Math.random() * 1000)}`,
      fileName: `new-image-${Date.now()}.jpg`,
      fileType: "Image",
      thumbnailUrl: previewUrl || "https://placehold.co/150x150/9333EA/FFFFFF?text=New",
      uploadDate: new Date().toISOString().split("T")[0],
    };
    onUpload(newItem);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Upload New Media">
      <div className="space-y-4">
        <ImageUpload
          label="Select Media"
          onUpload={(file, url) => {
            setFileSelected(!!file);
            setPreviewUrl(url);
          }}
          aspectRatio="square"
        />

        <div className="flex justify-end pt-4 space-x-3">
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSaveClick}
            disabled={!fileSelected}
          >
            Upload
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadMediaModal;
